import { unescape } from 'html-escaper';
import { DataCountryModel, DataProvinceModel, DataDistrictModel, DataSubdistrictModel } from '.';
import { SYSTEM_LANGUAGES } from '../actions/variables';
import { translate } from '../helpers/frontend';

export class ShippingAddressModel {
  constructor(data={}) {
    this._id = data?._id || null;

    this.addressLocal = data.addressLocal || SYSTEM_LANGUAGES[0];
    this.address = data.address? unescape(data.address): '';
    this.subdistrict = new DataSubdistrictModel(data.subdistrict || {});
    this.district = new DataDistrictModel(data.district || {});
    this.province = new DataProvinceModel(data.province || {});
    this.country = new DataCountryModel(data.country || {});
    this.zipcode = data.zipcode || '';

    this.lat = data.lat? Number(data.lat): null;
    this.lng = data.lng? Number(data.lng): null;

    this.addressText = data.addressText? unescape(data.addressText): '';

    this.shippingFirstname = data.shippingFirstname? unescape(data.shippingFirstname): '';
    this.shippingLastname = data.shippingLastname? unescape(data.shippingLastname): '';
    this.telephone = data.telephone || '';
    this.instruction = data.instruction? unescape(data.instruction): '';

    this.isPrimary = data.isPrimary? Number(data.isPrimary): 0;
    this.isSelected = data.isSelected? Number(data.isSelected): 0;
  }

  isValid() {
    return this._id? true: false;
  }

  prefixSubdistrict(lang='', langObj={}) {
    if(!lang || lang === 'TH'){
      if(!this.province.name) return 'แขวง / ตำบล';
      else if(this.province.name.includes('กรุงเทพ')) return 'แขวง';
      else return 'ตำบล';
    }else{
      return translate('Subdistrict', langObj);
    }
  }
  prefixDistrict(lang='', langObj={}) {
    if(!lang || lang === 'TH'){
      if(!this.province.name) return 'เขต / อำเภอ';
      else if(this.province.name.includes('กรุงเทพ')) return 'เขต';
      else return 'อำเภอ';
    }else{
      return translate('District', langObj);
    }
  }

  displayAddress(lang='', langObj={},isPDF = false) {
    if(lang === 'TH'){
      return !isPDF ? (<>
        <span>{this.address}</span> <br />
        {this.prefixSubdistrict()}{this.subdistrict.name} {this.prefixDistrict()}{this.district.name} <br />
        {this.province.name} ประเทศ{this.country.name} {this.zipcode}
      </>) : (<>
        {this.address}
        {this.prefixSubdistrict()}{this.subdistrict.name} {this.prefixDistrict()}{this.district.name} <br />
        {this.province.name} ประเทศ{this.country.name} {this.zipcode}
      </>
      )
    }else if(lang === 'EN'){
      return (<>
        <span>{this.address}</span> <br />
        Subdistrict {this.subdistrict.name}, District {this.district.name} <br />
        {this.province.name}, {this.country.name} {this.zipcode}
      </>);
    }else{
      return (<>
        <span>{this.address}</span> <br />
        {this.prefixSubdistrict(lang, langObj)} {this.subdistrict.name},
        {' '}{this.prefixDistrict(lang, langObj)} {this.district.name} <br />
        {translate('Province', langObj)} {this.province.name}, {this.country.name} {this.zipcode}
      </>);
    }
  }
  displayAddressLine(lang='', langObj={}) {
    if(lang === 'TH'){
      return (<>
        {this.address}
        {' '}{this.prefixSubdistrict()}{this.subdistrict.name} {this.prefixDistrict()}{this.district.name}
        {' '}{this.province.name} ประเทศ{this.country.name} {this.zipcode}
      </>);
    }else if(lang === 'EN'){
      return (<>
        {this.address}
        {', '}Subdistrict {this.subdistrict.name}, District {this.district.name}
        {', '}{this.province.name}, {this.country.name} {this.zipcode}
      </>);
    }else{
      return (<>
        {this.address}
        {', '}{this.prefixSubdistrict(lang, langObj)} {this.subdistrict.name}
        {', '}{this.prefixDistrict(lang, langObj)} {this.district.name}
        {', '}{translate('Province', langObj)} {this.province.name}, {this.country.name} {this.zipcode}
      </>);
    }
  }

  displayPrimary(langObj={}) {
    if(this.isValid()){
      if(this.isPrimary === 1) return (<span className="ss-tag bg-success">{translate('Yes', langObj)}</span>);
      else return (<span className="ss-tag bg-warning">{translate('No', langObj)}</span>);
    }else{
      return (<span className="ss-tag bg-warning">{translate('No', langObj)}</span>);
    }
  }
  displaySelected(langObj={}) {
    if(this.isValid()){
      if(this.isSelected === 1) return (<span className="ss-tag bg-success">{translate('In Use', langObj)}</span>);
      else return (<span className="ss-tag bg-warning">{translate('Not In Used', langObj)}</span>);
    }else{
      return (<span className="ss-tag bg-warning">{translate('Not In Used', langObj)}</span>);
    }
  }
}
